<section class="w3l-form-25">
  <div class="form-inner-cont">
          <h1>Customerts General Data</h1>
</div>
</section>
<div id="w3l-appointment">
<section class="appointment-section section-gap">

<div class="wrapper">
<div class="d-grid doctor-appointment">
    <div class="appointment-form">
        <form action="#" method="post">
            <div class="fields-grid">

              <!-- <div class="styled-input">
                <label>Date of 1st. Visit</label>
                  <div class="appointment-form-field">
                      <span class="fa fa-calendar" aria-hidden="true"></span>
                      <input type="date" [(ngModel)]="dateEntry" name="DateofDiagnosis" required style="width: 50%;" (change)="retrievePatient()">
                      <input type="text" name="year" required style="width: 20%;" hidden= "True" disabled  [(ngModel)]="yearEntry">
                    </div>

                </div> -->

              <div class="styled-input">
                <label>Customer Code</label>
                <div class="appointment-form-field">
                    <span class="fa fa-search"  style="cursor: grab;" (click)="openDialog()" aria-hidden="true"></span>
                    <input type="text" name="PatientCode" maxlength="8ch" placeholder="Customer Code" [(ngModel)]="patientCode" (change)="retrievePatient()"  required="" style="width: 30%;"  maxlength="8"/>

                </div>
              </div>
              <div class="styled-input">
                <label>Customer Name</label>
                <div class="appointment-form-field">
                    <span class="fa fa-user" aria-hidden="true"></span>
                    <input type="text" name="PatientName" placeholder="Customer Name" [(ngModel)]="patientFName" required="">

                </div>
              </div>
              <!-- <div class="styled-input">
                <label>Diagnosis</label>
                <br>
                <br>
                <div class="appointment-form-field">
                  <span class="fa fa-line-chart" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows = "5" cols = "60" name = "Diagnosis" [(ngModel)]= "diagnosis" class="appointment-form-field" style="height: 200%;"> Enter details here... </textarea><br>

                </div>
              </div> -->
              <!-- <div class="styled-input">
                <label>Date of Birth</label>

                  <div class="appointment-form-field">
                      <span class="fa fa-calendar" aria-hidden="true"></span>
                      <input type="date" name="BirthDate"  [(ngModel)]= "birthDate" required  (change)="calculateAge()">
                      <label style="width: 45%;"></label>
                      <label>Age</label>
                      <div class="appointment-form-field">
                          <input type="text" name="ageYear" [(ngModel)]="ageYear"  required style="width: 100%;" >
                      </div>

                  </div>
                </div> -->


                <!-- Cancer Type -->
                <!-- <div class="styled-input">
                  <label>Cancer Type</label>
                  <div class="appointment-form-field">
                      <span class="fa fa-heartbeat" aria-hidden="true"></span>
                      <select id="CancerType" name="CancerType" [(ngModel)]= "cancerID" [value]="cancerID" required>
                        <option value="{{Canc.cancerID}}" *ngFor="let Canc of cancerlist; let i = index">{{Canc.cancerName}}</option>

                      </select>
                  </div>
                </div> -->
              <div class="styled-input">
                <label>Mobile</label>
                <div class="appointment-form-field">
                    <span class="fa fa-mobile" aria-hidden="false"></span>
                    <input type="text" name="telMobile" [(ngModel)]="telMobile" required >
                </div>
              </div>
            <!-- <div class="styled-input">
                <label>Pathology</label>
                <div class="appointment-form-field">
                    <span class="fa fa-bookmark" aria-hidden="true"></span>
                    <select id="PathologyID" name="PathologyName" [(ngModel)]= "pathology" [value]="pathology" required>
                      <option value="{{Patholo.pathTypeCode}}" *ngFor="let Patholo of PathologyList; let i = index">{{Patholo.pathTypeName}}</option>
                    </select>
                </div>
            </div> -->
            <!-- Master Status -->
            <!-- <div class="styled-input">
              <label>Master Status</label>
              <div class="appointment-form-field">
                  <span class="fa fa-pencil-square-o" aria-hidden="true"></span>
                  <select id="Masterstatus" name="sad" [(ngModel)]= "status"  [value]="status" required (change)="hiedMort()">
                    <option value="{{Mastr.serials}}" *ngFor="let Mastr of MasterList1;  let i = index">{{Mastr.lookupNames}}</option>
                  </select>
                  <button type="button" class="theme-button btn" name="submit" style="height: 45px;" (click)="EditMortality()" [disabled] = wk_Hied_Mortal>Mortality Info</button>
              </div>
            </div> -->
            <div class="styled-input">
              <label>Tel1</label>
              <div class="appointment-form-field">
                  <span class="fa fa-phone" aria-hidden="false"></span>
                  <input type="text" name="telHome" [(ngModel)]= "telHome" required >

              </div>

            </div>
            <div class="styled-input">
              <label>Tel2</label>
              <div class="appointment-form-field">
                  <span class="fa fa-phone" aria-hidden="false"></span>
                  <input type="text" name="telBusin" [(ngModel)]= "telBusin" required >


              </div>

            </div>

            </div>
        </form>
    </div>


  <div class="fields-grid">
<!--
    <div class="styled-input">
      <label>Marital Status</label>
      <div class="appointment-form-field">
          <span class="fa fa-street-view" aria-hidden="true"></span>
          <select id="Maritalstatus" [(ngModel)]=  "marital" required style="width: 20%">
              <option value="0">Single</option>
              <option value="Married">Married</option>
              <option value="2">Divorced</option>
              <option value="3">Widow/Widower</option>
              <option value="4">Separated</option>


          </select>

          <span class="fa fa-user-plus" aria-hidden="true"></span>
          <select id="Maritalstatus" [(ngModel)]= "gender" required style="width: 25%" [(ngModel)]= "gender">
              <option value="Male">Male</option>
              <option value="Female">Female</option>

          </select>
              <label style="width: 5%;"></label>
                 <img [hidden]= "wk_Acc_Not" src="assets/images/NoInsurance.jpg"  alt="Item Image" width="180px" height="75px" style="border: 1px;border-style: double;cursor: grab;" (click)="OpenDialogPatientInsurance()"/>

                 <img [hidden]= "wk_Acc_Not1" src="data:image/jpg;base64,{{myimage}}"  alt="Item Image" width="180px" height="75px" style="border: 1px;border-style: double;cursor: grab;" (click)="OpenDialogPatientInsurance()"/>


      </div>


  </div> -->

    <!-- <div class="styled-input">
      <label>Doctor</label>
      <div class="appointment-form-field">
          <span class="fa fa-headphones" aria-hidden="true"></span>

          <select id="Doctor" name="Doctor" required="" [(ngModel)]="docCode" [value]="docCode">
            <option value="{{doc.docCode}}" *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}</option>
        </select>

      </div>
  </div> -->
  <!-- <div class="styled-input">
    <label>Education</label>
    <div class="appointment-form-field">
        <span class="	fa fa-mortar-board" aria-hidden="true"></span>
        <select id="Education" name="Education" [(ngModel)]="education" [value]="education" required >
          <option value="{{x.serials}}" *ngFor="let x of MasterList2; let i = index">{{x.lookupNames}}</option>
        </select>

    </div>

</div> -->
<div class="styled-input">
  <label>Nationality</label>
  <div class="appointment-form-field">
      <span class="fa fa-flag" aria-hidden="true"></span>
      <select id="nationality" [(ngModel)]="nationality" required >
        <option value="{{x.lookupNames}}" *ngFor="let x of MasterListNat; let i = index">{{x.lookupNames}}</option>
      </select>

  </div>

</div>

 <div class="styled-input">
  <label>Governorate</label>
  <div class="appointment-form-field">
      <span class="fa fa-map-marker" aria-hidden="true"></span>
      <select id="Governorate_1" [(ngModel)]="gov" required >
        <option value="{{x.govename}}" *ngFor="let x of MasterListGov; let i = index">{{x.govename}}</option>
      </select>

  </div>

</div>
<!-- Occupation -->
<!-- <div class="styled-input">
  <label>Occupation</label>
  <div class="appointment-form-field">
      <span class="fa fa-handshake-o" aria-hidden="false"></span>
      <input type="text" id="Accupation" [(ngModel)]="occupation" required >


  </div>

</div> -->

<div class="styled-input">
  <label>Email</label>
  <div class="appointment-form-field">
      <span class="fa fa-send" aria-hidden="false"></span>
      <input type="text" id="Email" [(ngModel)]="email" required >
  </div>

</div>
<!-- <div class="styled-input">
  <label>Sites</label>
  <div class="appointment-form-field">
      <span class="fa fa-laptop" aria-hidden="true"></span>
      <select id="location" name="location" [(ngModel)]= "compCode" [value]="compCode" required>
        <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
      </select>
  </div>
</div> -->
<div class="styled-input">


  <label>Address</label>
  <br>
  <br>
  <br> <br>
  <div class="appointment-form-field">
      <span class="fa fa-university" aria-hidden="true" style="height: 370%;"></span>
      <textarea rows = "5" cols = "60" name = "Address" [(ngModel)]= "addressHome" class="appointment-form-field" style="height: 370%;"> Enter details here... </textarea><br>
  </div>
</div>

</div>



</div>

</div>
</section>
</div>
<div id="w3l-appointment">
  <div class="wrapper">
  <div class="appointment-form" style="text-align: center;">
  <button type="button" class="theme-button btn" name="submit" (click)="submiPatientData()">Submit</button>
  <button type="button" class="theme-button btn" name="Delete" (click)="MesgDelete()">Delete</button>
  <button type="button" class="theme-button btn" name="New" (click)="ClearPatientData()">New</button>
  <a href="Home">
    <button type="button" class="theme-button btn"  name="Back">Home</button>
  </a>

</div>
<BR>
  <BR>  <BR>


